<template>
  <div v-if="!isReloading" id="app" @click="checkTimer">
    <router-view v-if="isRouterRefresh" />

    <ku-message-box
      type="info"
      :text="$t('温馨提示')"
      :tip="needReloadTime ? $t('当前页面长时间未操作，请点击确定刷新页面，倒计时内无操作则自动刷新') : $t('当前页面长时间未操作，请点击确定刷新页面')"
      :visible.sync="visible"
      :confirm-btn-cfg="{
        text: $t('刷新'),
        countdown: needReloadTime && autoReloadTime,
        autoClick: needReloadTime,
        disableWhenCount: false
      }"
      :is-ads="false"
      :need-close="false"
      @confirm="onConfirm"
    />
  </div>
</template>

<script>
import db from '@klinx/utils/localstorage';
import { baseAuthorityApi } from '@klinx/base/src/api/index.js';
import { mapGetters } from 'vuex';

const EXPIRE_TIME = 30; // 设30分钟
const RELOAD_TIME = 1; // 1分钟

export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload,
      setExpireTimerFlag: this.setExpireTimerFlag
    };
  },
  data() {
    return {
      isReloading: false,
      exprieTimer: null,
      lastClickTime: null,
      currentClickTime: null,
      isRouterRefresh: false,
      visible: false,
      needTimer: true,
      excludeTimerApps: ['home', 'iSmartBI'],
      excludeTimerPaths: ['smart-bi', 'kanban']
    };
  },
  computed: {
    expireWatchTime() {
      // 注意：如果初始本地没有配置缓存时，第一次写入不会马上取到（$route的watch里checkTimer还没拿到envConfig），只有页面跳转或刷新或有点击才会取到缓存里的配置，问题不大
      return 1000 * 60 * (window.sessionStorage.getItem('expTime') || this.envConfig?.VUE_APP_OPERATE_EXPIRE_TIME || process.env.VUE_APP_OPERATE_EXPIRE_TIME || EXPIRE_TIME); // 监听不操作时长，加缓存方便测试
    },
    needReloadTime() {
      return window.sessionStorage.getItem('reload') || this.envConfig?.VUE_APP_AUTO_RELOAD_TENTANT || process.env.VUE_APP_AUTO_RELOAD_TENTANT; // 默认按租户配置，加缓存方便测试
    },
    autoReloadTime() {
      return 60 * (this.envConfig?.VUE_APP_OPERATE_EXPIRE_RELOAD_TIME || process.env.VUE_APP_OPERATE_EXPIRE_RELOAD_TIME || RELOAD_TIME); // 超时不操作-自动刷新时间，加缓存方便测试
    },
    ...mapGetters([
      'currentApp',
      'envConfig'
    ])
  },
  watch: {
    $route(to, from) {
      // 每次切换路由重置计时器，部分页面、模块不需要监听
      if (this.excludeTimerPaths.some(p => to.path.includes(p)) || this.excludeTimerApps.includes(this.currentApp?.code) || to.query.noAppTimer) {
        this.needTimer = false;
      }
      this.checkTimer(); // 重置
      const userToken = (this.$route.query.userToken || '').replace('Bearer', '').trim();
      if (process.env.VUE_APP_TENANT_USER_TOKEN_ENABLE && userToken && userToken !== this.$store.state.account?.token) {
        this.$store.commit('account/setToken', userToken);
        baseAuthorityApi.verifyToken({ token: `Bearer ${userToken}` }).then(res => {
          if (res.data.isSuccess) {
            const user = res.data.data || {};
            this.$store.commit('account/setUser', {
              id: user.userId,
              account: user.account,
              name: user.name,
              avatar: user.avatar,
              workDescribe: user.workDescribe
            });
            this.isRouterRefresh = true;
          }
        });
      } else {
        this.isRouterRefresh = true;
      }
      this.addCachedViews();
    },
    // 需要计时器时触发
    needTimer(flag) {
      if (flag) {
        this.checkTimer();
      }
    }
  },
  mounted() {
    // 解决页面刷新不触发内部组件deforeDestory问题
    window.addEventListener('beforeunload', () => {
      this.isReloading = true;
      this.clearTimer();
      this.$eventBus.$off('onAppReload');
      this.$eventBus.$off('updateAppRoute');
      window.removeEventListener('beforeunload', () => {});
    });
  },
  methods: {
    addCachedViews() {
      const { name } = this.$route;
      if (name) {
        this.$store.dispatch('tagsView/addView', this.$route);
      }
      return false;
    },
    /**
     * 设置超时监听计时器标记
     */
    setExpireTimerFlag(flag) {
      this.needTimer = flag;
    },
    /**
     * 设置超时未操作页面（点击）定时器，定时提示刷新
     */
    setExpireTimer() {
      this.exprieTimer = setTimeout((self) => {
        self.$eventBus.$emit('onAppReload'); // 业务页面自主定义事件，比如停止定时任务
        self.visible = true;
        self.clearTimer();
      }, this.expireWatchTime, this);
    },
    /**
     * 检查计时重置
     */
    checkTimer() {
      if (!this.visible && !!db.get('TOKEN', '')) {
        this.clearTimer();
        this.needTimer && this.setExpireTimer();
      }
    },
    /**
     * 清除计时器
     */
    clearTimer() {
      if (this.exprieTimer) {
        clearTimeout(this.exprieTimer);
        this.exprieTimer = null;
      }
    },
    onConfirm() {
      window.location.reload();
    },
    reload() {
      this.isRouterRefresh = false;
      this.$nextTick(() => {
        this.isRouterRefresh = true;
      });
    }
  }
};
</script>
<style>
  #nprogress .bar{
    background: #FF6900!important;
  }
  .vue-treeselect__control{
    height: 32px!important;
  }
  .expand .el-button-group>.el-button:first-child{
    border-top-right-radius: 0!important;
    border-bottom-right-radius: 0!important;
  }
  .expand .el-button-group>.el-button:last-child{
    border-top-left-radius: 0!important;
    border-bottom-left-radius: 0!important;
  }
</style>
